var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10671_67348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.93404 7.6748C2.19952 6.7267 2.67385 5.89577 3.2933 5.23174C3.08446 5.0755 2.25616 4.42922 2.21722 3.92143C2.15705 3.09051 2.98534 0.295898 2.98534 0.295898C2.98534 0.295898 0.482751 3.35328 0.309304 4.58901C0.171255 5.55843 1.75352 7.48305 1.91988 7.67835V7.6748H1.93404ZM12.1179 7.62509V7.63219C12.1179 7.63574 12.1214 7.63929 12.1214 7.64284C12.3975 7.30905 13.8311 5.51582 13.7001 4.58901C13.5267 3.35328 11.0241 0.295898 11.0241 0.295898C11.0241 0.295898 11.8524 3.09051 11.7922 3.92143C11.7568 4.40792 11.0028 5.01513 10.7515 5.20688C11.371 5.86026 11.8488 6.68408 12.1179 7.62509Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.118 7.62862V7.62152C11.8489 6.68406 11.3711 5.86024 10.7516 5.20331C9.7782 4.17353 8.45434 3.55566 7.02783 3.55566V6.85806H7.03137C7.3818 6.86161 7.66498 7.14924 7.66498 7.50079C7.66498 7.5434 7.66144 7.58246 7.65436 7.62152C7.59773 7.91625 7.34287 8.13996 7.03137 8.14351H7.02075V9.36859L7.01367 15.1709H7.13756C7.13756 15.1709 8.48266 13.2178 9.20831 12.6603C10.0578 12.007 12.118 11.1973 12.118 11.1973V7.66768L12.1286 7.66413C12.125 7.65703 12.125 7.64638 12.1215 7.63927C12.1215 7.63572 12.1215 7.63217 12.118 7.62862Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.02104 9.3721V8.14702C6.72725 8.14347 6.483 7.94461 6.40867 7.67474C6.39451 7.62148 6.38389 7.56466 6.38389 7.50429C6.38389 7.1492 6.67061 6.86157 7.02458 6.86157H7.02812V3.56982C5.59453 3.56982 4.26713 4.19124 3.2937 5.23168C2.67425 5.89216 2.19993 6.72663 1.93445 7.67474H1.92383V11.2506C1.92383 11.2506 3.98395 12.0602 4.83349 12.7136C5.5379 13.2569 6.89715 15.1779 6.89715 15.1779H7.02458V15.1744H7.0175L7.02104 9.3721Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10671_67348"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 15.4737,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpa);
export default __webpack_public_path__ + "static/media/opa.73447b8d.svg";
export { ForwardRef as ReactComponent };